const dummyJobs = [
  {
    id: 1,
    title: "Senior Product Designer",
    company: "Google",
    companyInitial: "G",
    companyColor: "#4285f4",
    location: "Bangalore, India",
    salary: "₹80k – ₹1.2L/mo",
    type: "Full Time",
    mode: "Hybrid",
    experience: "5+ years",
    postedDays: 2,
    tags: ["Figma", "UX Research", "Design Systems"],
    featured: true,
    description: `We are looking for a talented Senior Product Designer to join our team at Google. You will be responsible for driving the design of complex product features across multiple platforms.`,
    responsibilities: [
      "Lead design for key product areas across web and mobile",
      "Collaborate with product managers and engineers to define product vision",
      "Conduct user research and usability testing",
      "Create wireframes, prototypes, and high-fidelity mockups",
      "Mentor junior designers and contribute to design system",
      "Present design work to leadership and stakeholders",
    ],
    requirements: [
      "5+ years of product design experience",
      "Expert proficiency in Figma and design tools",
      "Strong portfolio demonstrating end-to-end design process",
      "Experience with design systems and component libraries",
      "Excellent communication and presentation skills",
      "Bachelor's degree in Design, HCI, or related field",
    ],
    benefits: [
      "Competitive salary + equity",
      "Health, dental, and vision insurance",
      "Flexible work hours",
      "Annual learning budget of ₹1.5L",
      "Home office stipend",
      "30 days paid vacation",
    ],
    companySize: "10,000+ employees",
    industry: "Technology",
    founded: "1998",
    website: "google.com",
  },
  {
    id: 2,
    title: "Frontend Developer",
    company: "Microsoft",
    companyInitial: "M",
    companyColor: "#00a4ef",
    location: "Mumbai, India",
    salary: "₹60k – ₹1L/mo",
    type: "Full Time",
    mode: "Remote",
    experience: "3+ years",
    postedDays: 1,
    tags: ["React", "TypeScript", "CSS"],
    featured: true,
    description: `Join Microsoft's world-class engineering team and build products that impact billions of users. We're looking for a passionate Frontend Developer to work on cutting-edge web applications.`,
    responsibilities: [
      "Build responsive and accessible web applications using React",
      "Write clean, maintainable TypeScript code",
      "Collaborate with designers to implement pixel-perfect UI",
      "Optimize application performance and loading speeds",
      "Write unit and integration tests",
      "Participate in code reviews",
    ],
    requirements: [
      "3+ years of frontend development experience",
      "Strong proficiency in React and TypeScript",
      "Experience with state management (Redux, Zustand)",
      "Understanding of web accessibility standards",
      "Experience with testing frameworks (Jest, RTL)",
      "Good understanding of CSS and responsive design",
    ],
    benefits: [
      "Competitive salary + performance bonus",
      "Comprehensive health insurance",
      "Remote work flexibility",
      "Microsoft product discounts",
      "Learning & development programs",
      "Parental leave",
    ],
    companySize: "220,000+ employees",
    industry: "Technology",
    founded: "1975",
    website: "microsoft.com",
  },
  {
    id: 3,
    title: "Data Scientist",
    company: "Amazon",
    companyInitial: "A",
    companyColor: "#ff9900",
    location: "Hyderabad, India",
    salary: "₹90k – ₹1.5L/mo",
    type: "Full Time",
    mode: "On-site",
    experience: "4+ years",
    postedDays: 3,
    tags: ["Python", "Machine Learning", "SQL"],
    featured: false,
    description: `Amazon is seeking a Data Scientist to join our team and help drive data-driven decision making across our business units. You'll work on complex problems at massive scale.`,
    responsibilities: [
      "Develop and deploy machine learning models at scale",
      "Analyze large datasets to extract actionable insights",
      "Collaborate with business teams to define metrics and KPIs",
      "Build data pipelines and ETL workflows",
      "Present findings to senior leadership",
      "Mentor junior data scientists",
    ],
    requirements: [
      "4+ years of data science experience",
      "Expert Python skills (pandas, scikit-learn, TensorFlow)",
      "Strong SQL and database knowledge",
      "Experience with cloud platforms (AWS preferred)",
      "Statistics and probability fundamentals",
      "Master's or PhD in a quantitative field preferred",
    ],
    benefits: [
      "Top-of-market compensation",
      "Relocation assistance",
      "Comprehensive benefits package",
      "Employee discount on Amazon products",
      "Career growth opportunities",
      "Stock options (RSUs)",
    ],
    companySize: "1.5M+ employees",
    industry: "E-commerce & Technology",
    founded: "1994",
    website: "amazon.com",
  },
  {
    id: 4,
    title: "DevOps Engineer",
    company: "Infosys",
    companyInitial: "I",
    companyColor: "#007cc3",
    location: "Pune, India",
    salary: "₹50k – ₹80k/mo",
    type: "Full Time",
    mode: "Hybrid",
    experience: "2+ years",
    postedDays: 5,
    tags: ["Docker", "Kubernetes", "AWS"],
    featured: false,
    description: `Infosys is looking for a skilled DevOps Engineer to manage and improve our cloud infrastructure and CI/CD pipelines. You'll play a key role in our digital transformation journey.`,
    responsibilities: [
      "Maintain and improve CI/CD pipelines",
      "Manage cloud infrastructure on AWS/Azure",
      "Implement container orchestration with Kubernetes",
      "Monitor system health and respond to incidents",
      "Automate repetitive operational tasks",
      "Ensure security and compliance best practices",
    ],
    requirements: [
      "2+ years of DevOps experience",
      "Proficiency in Docker and Kubernetes",
      "AWS certification preferred",
      "Experience with Terraform or Ansible",
      "Strong Linux/Unix administration skills",
      "Good scripting skills (Bash, Python)",
    ],
    benefits: [
      "Competitive salary",
      "Health and life insurance",
      "Transport allowance",
      "Professional certifications sponsored",
      "Flexible working hours",
      "Annual performance bonus",
    ],
    companySize: "350,000+ employees",
    industry: "IT Services",
    founded: "1981",
    website: "infosys.com",
  },
  {
    id: 5,
    title: "Backend Engineer",
    company: "Flipkart",
    companyInitial: "F",
    companyColor: "#2874f0",
    location: "Bangalore, India",
    salary: "₹70k – ₹1.1L/mo",
    type: "Full Time",
    mode: "On-site",
    experience: "3+ years",
    postedDays: 4,
    tags: ["Node.js", "PostgreSQL", "Redis"],
    featured: true,
    description: `Flipkart is India's leading e-commerce platform. We're looking for a Backend Engineer to build scalable services that handle millions of transactions daily.`,
    responsibilities: [
      "Design and build high-performance backend APIs",
      "Work with distributed databases and caching systems",
      "Ensure reliability, scalability and performance",
      "Collaborate with frontend and mobile teams",
      "Write comprehensive tests for your code",
      "Participate in on-call rotations",
    ],
    requirements: [
      "3+ years of backend development experience",
      "Strong Node.js or Java skills",
      "Experience with PostgreSQL and Redis",
      "Understanding of microservices architecture",
      "Knowledge of message queues (Kafka, RabbitMQ)",
      "Good understanding of REST API design",
    ],
    benefits: [
      "Competitive compensation",
      "Employee stock options",
      "Health insurance for family",
      "Free meals at office",
      "Gym membership",
      "Learning and development budget",
    ],
    companySize: "50,000+ employees",
    industry: "E-commerce",
    founded: "2007",
    website: "flipkart.com",
  },
  {
    id: 6,
    title: "Mobile App Developer",
    company: "Paytm",
    companyInitial: "P",
    companyColor: "#002970",
    location: "Noida, India",
    salary: "₹55k – ₹90k/mo",
    type: "Full Time",
    mode: "Remote",
    experience: "2+ years",
    postedDays: 6,
    tags: ["React Native", "Flutter", "iOS"],
    featured: false,
    description: `Join Paytm's mobile engineering team to build apps used by 350M+ users across India. You'll be crafting features that help people pay, invest, and bank digitally.`,
    responsibilities: [
      "Build cross-platform mobile applications",
      "Optimize app performance for low-end devices",
      "Integrate payment SDKs and APIs",
      "Write clean, testable code",
      "Work closely with design and product teams",
      "Review app metrics and improve user experience",
    ],
    requirements: [
      "2+ years of mobile development experience",
      "Proficiency in React Native or Flutter",
      "Understanding of native iOS/Android development",
      "Experience with payment integrations",
      "Strong debugging and performance optimization skills",
      "Published apps on Play Store/App Store",
    ],
    benefits: [
      "Competitive salary",
      "Work from home flexibility",
      "Health insurance",
      "Annual bonus",
      "Paytm wallet credits",
      "Learning stipend",
    ],
    companySize: "10,000+ employees",
    industry: "Fintech",
    founded: "2010",
    website: "paytm.com",
  },
  {
    id: 7,
    title: "UI/UX Designer",
    company: "Zomato",
    companyInitial: "Z",
    companyColor: "#e23744",
    location: "Gurgaon, India",
    salary: "₹45k – ₹75k/mo",
    type: "Full Time",
    mode: "Hybrid",
    experience: "2+ years",
    postedDays: 7,
    tags: ["Adobe XD", "Figma", "Prototyping"],
    featured: false,
    description: `Zomato is looking for a creative UI/UX Designer to craft beautiful, intuitive experiences for our food delivery and dining apps used by millions across 24 countries.`,
    responsibilities: [
      "Design intuitive user flows and wireframes",
      "Create high-fidelity mockups and prototypes",
      "Conduct user research and usability testing",
      "Maintain and evolve the design system",
      "Collaborate with product and engineering teams",
      "Present design rationale to stakeholders",
    ],
    requirements: [
      "2+ years of UI/UX design experience",
      "Proficiency in Figma and Adobe XD",
      "Strong portfolio with mobile design projects",
      "Understanding of user-centered design principles",
      "Ability to handle multiple projects simultaneously",
      "Experience with animation and micro-interactions",
    ],
    benefits: [
      "Competitive salary",
      "Free Zomato Pro subscription",
      "Health and wellness benefits",
      "Stock options",
      "Flexible work hours",
      "Team lunches and activities",
    ],
    companySize: "5,000+ employees",
    industry: "Food Tech",
    founded: "2008",
    website: "zomato.com",
  },
  {
    id: 8,
    title: "Product Manager",
    company: "Swiggy",
    companyInitial: "S",
    companyColor: "#fc8019",
    location: "Bangalore, India",
    salary: "₹1L – ₹1.6L/mo",
    type: "Full Time",
    mode: "On-site",
    experience: "5+ years",
    postedDays: 2,
    tags: ["Product Strategy", "Agile", "Analytics"],
    featured: true,
    description: `Swiggy is India's most valued food-tech company. We are looking for an experienced Product Manager to lead key product initiatives and drive business impact.`,
    responsibilities: [
      "Define product vision, strategy, and roadmap",
      "Work with engineering, design, and data teams",
      "Analyze user behavior and market trends",
      "Write clear product requirements and user stories",
      "Drive cross-functional alignment and execution",
      "Launch and iterate on features rapidly",
    ],
    requirements: [
      "5+ years of product management experience",
      "Proven track record of launching successful products",
      "Strong analytical and data-driven mindset",
      "Excellent communication and leadership skills",
      "Experience with consumer internet products",
      "MBA from a top-tier institution preferred",
    ],
    benefits: [
      "Top-tier compensation package",
      "Swiggy One subscription",
      "Health insurance for family",
      "Stock options",
      "Learning & development budget",
      "Annual off-sites",
    ],
    companySize: "5,000+ employees",
    industry: "Food Tech",
    founded: "2014",
    website: "swiggy.com",
  },
  {
    id: 9,
    title: "Machine Learning Engineer",
    company: "NVIDIA",
    companyInitial: "N",
    companyColor: "#76b900",
    location: "Remote",
    salary: "₹1.2L – ₹2L/mo",
    type: "Full Time",
    mode: "Remote",
    experience: "4+ years",
    postedDays: 1,
    tags: ["PyTorch", "TensorFlow", "CUDA"],
    featured: true,
    description: `NVIDIA is at the forefront of AI and GPU computing. Join our research team to develop state-of-the-art machine learning models and GPU-accelerated algorithms.`,
    responsibilities: [
      "Develop and optimize deep learning models",
      "Implement GPU-accelerated algorithms using CUDA",
      "Research and prototype novel ML architectures",
      "Collaborate with researchers and product teams",
      "Write clean, well-documented code",
      "Publish research findings",
    ],
    requirements: [
      "4+ years of ML engineering experience",
      "Expert in PyTorch or TensorFlow",
      "Experience with CUDA programming",
      "Strong mathematics: linear algebra, statistics",
      "Track record of deploying models to production",
      "MS/PhD in CS, ML, or related field preferred",
    ],
    benefits: [
      "Industry-leading compensation",
      "100% remote work",
      "Top-tier health benefits",
      "NVIDIA hardware discounts",
      "Conference and publication support",
      "Generous equity package",
    ],
    companySize: "29,000+ employees",
    industry: "Semiconductors & AI",
    founded: "1993",
    website: "nvidia.com",
  },
  {
    id: 10,
    title: "Cybersecurity Analyst",
    company: "Wipro",
    companyInitial: "W",
    companyColor: "#341d74",
    location: "Chennai, India",
    salary: "₹60k – ₹95k/mo",
    type: "Full Time",
    mode: "On-site",
    experience: "3+ years",
    postedDays: 8,
    tags: ["SIEM", "Penetration Testing", "CISSP"],
    featured: false,
    description: `Wipro is seeking a Cybersecurity Analyst to protect our clients' digital assets and infrastructure. You'll be part of a global security operations team working on cutting-edge threats.`,
    responsibilities: [
      "Monitor security events using SIEM tools",
      "Perform vulnerability assessments and penetration testing",
      "Respond to security incidents and breaches",
      "Develop security policies and procedures",
      "Conduct security awareness training",
      "Prepare security audit reports",
    ],
    requirements: [
      "3+ years in cybersecurity",
      "Experience with SIEM tools (Splunk, QRadar)",
      "Knowledge of penetration testing methodologies",
      "CISSP, CEH, or OSCP certification preferred",
      "Familiarity with security frameworks (NIST, ISO 27001)",
      "Strong analytical and problem-solving skills",
    ],
    benefits: [
      "Competitive salary",
      "Health insurance",
      "Certification reimbursement",
      "Flexible shifts",
      "Annual performance bonus",
      "Employee stock purchase plan",
    ],
    companySize: "250,000+ employees",
    industry: "IT Services",
    founded: "1945",
    website: "wipro.com",
  },
  {
    id: 11,
    title: "Cloud Architect",
    company: "TCS",
    companyInitial: "T",
    companyColor: "#1c2d6b",
    location: "Mumbai, India",
    salary: "₹1.1L – ₹1.8L/mo",
    type: "Full Time",
    mode: "Hybrid",
    experience: "7+ years",
    postedDays: 3,
    tags: ["AWS", "Azure", "GCP"],
    featured: false,
    description: `TCS is looking for an experienced Cloud Architect to design and implement enterprise cloud solutions for our global clients. You'll drive cloud adoption and migration strategies.`,
    responsibilities: [
      "Design multi-cloud architecture solutions",
      "Lead cloud migration and modernization projects",
      "Define cloud governance and security frameworks",
      "Mentor teams on cloud best practices",
      "Optimize cloud costs and performance",
      "Engage with client stakeholders",
    ],
    requirements: [
      "7+ years of cloud architecture experience",
      "Certifications in AWS, Azure, or GCP",
      "Experience with IaC tools (Terraform, CloudFormation)",
      "Strong networking and security knowledge",
      "Excellent client communication skills",
      "Experience with enterprise-scale deployments",
    ],
    benefits: [
      "Competitive compensation",
      "Global travel opportunities",
      "Health and life insurance",
      "Certification support",
      "Annual bonus",
      "Provident fund",
    ],
    companySize: "600,000+ employees",
    industry: "IT Services",
    founded: "1968",
    website: "tcs.com",
  },
  {
    id: 12,
    title: "Full Stack Developer",
    company: "Razorpay",
    companyInitial: "R",
    companyColor: "#2EB872",
    location: "Bangalore, India",
    salary: "₹75k – ₹1.2L/mo",
    type: "Full Time",
    mode: "Hybrid",
    experience: "3+ years",
    postedDays: 5,
    tags: ["React", "Go", "PostgreSQL"],
    featured: false,
    description: `Razorpay is India's leading fintech platform. Join us to build the payment infrastructure that powers businesses of all sizes across the country.`,
    responsibilities: [
      "Build scalable full-stack features for payments platform",
      "Design and implement APIs used by thousands of merchants",
      "Write efficient database queries and migrations",
      "Ensure application security and compliance",
      "Participate in technical design discussions",
      "Help grow the engineering culture",
    ],
    requirements: [
      "3+ years of full-stack development experience",
      "Proficiency in React and Go or Node.js",
      "Strong understanding of databases and SQL",
      "Experience with payment systems is a plus",
      "Good understanding of security best practices",
      "Ability to work in a fast-paced environment",
    ],
    benefits: [
      "Competitive salary + equity",
      "Health insurance for family",
      "Remote work options",
      "Learning budget",
      "Team retreats",
      "Flexible working hours",
    ],
    companySize: "2,500+ employees",
    industry: "Fintech",
    founded: "2014",
    website: "razorpay.com",
  },
];

export default dummyJobs;
